import { getBrowserName } from './getBrowserName'

type TutorialLoader = () => Promise<{ default: string }>

// Which "add to home screen" screen recording to play, keyed by browser.
//
// Loaded lazily so each clip ships as its own chunk: a visitor only ever needs
// the one for their browser, and the four Android recordings total ~14 MB.
//
// `safari` is the iPhone entry — every iOS browser reports as Safari here,
// because Chrome and Firefox on iPhone are WebKit shells whose user agent
// carries neither 'chrome' nor 'firefox' (they use 'CriOS' / 'FxiOS'). Without
// it an iOS tap had nothing to play, which is why iPhones fell through to the
// static step images while emulated iPhones (still on a desktop Chrome user
// agent) played the Android clip.
//
// The iOS recording is fun_88_global's `ios-safari/CL.mp4` — the one it falls
// back to for MX, since no Mexico recording exists. Its address bar reads
// fun88.cl; swap in an MX capture when there is one.
const PWA_TUTORIALS: Record<string, TutorialLoader> = {
  brave: () => import('../assets/pwa-video-tutorial/pwa_chrome_brave.mp4'),
  chrome: () => import('../assets/pwa-video-tutorial/pwa_chrome_brave.mp4'),
  firefox: () => import('../assets/pwa-video-tutorial/pwa_firefox.mp4'),
  opera: () => import('../assets/pwa-video-tutorial/pwa_opera.mp4'),
  safari: () => import('../assets/pwa-video-tutorial/pwa_ios_safari.mp4'),
  samsung: () => import('../assets/pwa-video-tutorial/pwa_samsung.mp4'),
}

// Resolves to the clip for the current browser, or '' when it has none, so
// callers can fall back to the static steps instead of opening a blank player.
// Rejects if the chunk itself fails to load — offline, or a stale hashed asset
// after a deploy — which callers must handle separately from "no clip exists".
export const loadPwaTutorialVideo = async () => {
  const loader = PWA_TUTORIALS[getBrowserName()]
  if (!loader) return ''

  const tutorial = await loader()
  return tutorial.default
}
